export const DOCS_APP_BASE_URL =
  process.env.REACT_APP_APP_BASE_URL || 'http://localhost:3001';

/** Typical end-to-end query duration (~1 min). */
export const QUERY_LOADING_TOTAL_DURATION_MS = 60_000;

export const QUERY_LOADING_STEPS = [
  {
    label: 'Fetching relevant documents...',
    durationMs: 30_000,
  },
  {
    label: 'Analyzing document content...',
    durationMs: 9_000,
  },
  {
    label: 'Checking relevance scores...',
    durationMs: 8_000,
  },
  {
    label: 'Ranking top matches...',
    durationMs: 7_000,
  },
  {
    label: 'Synthesizing response...',
    durationMs: 6_000,
  },
] as const;

export const QUERY_LOADING_PROGRESS_TICK_MS = 250;

export const getQueryLoadingStepDelayMs = (stepIndex: number): number =>
  QUERY_LOADING_STEPS.slice(0, stepIndex).reduce(
    (total, step) => total + step.durationMs,
    0
  );

export const buildDocsQueryUrl = (query: string): string => {
  const encodedQuery = encodeURIComponent(query);
  return `${DOCS_APP_BASE_URL}/?q=${encodedQuery}`;
};
